document.addEventListener('DOMContentLoaded', function() {
  // Get all <summary> elements within <details>
  const summaryElements = document.querySelectorAll('.mega-menu summary');

  summaryElements.forEach(summary => {
    summary.addEventListener('click', function(event) {
      // Prevent default summary behavior
      event.preventDefault();
      
      const details = this.parentElement;
      const submenu = details.querySelector('.mega-menu__content');
      const isOpen = details.hasAttribute('open');
      
      // Close all other open details
      summaryElements.forEach(sum => {
        const parentDetails = sum.parentElement;
        if (parentDetails !== details) {
          parentDetails.removeAttribute('open');
          parentDetails.querySelector('.mega-menu__content').classList.remove('open');
        }
      });
      
      // Toggle the current submenu and body class
      if (isOpen) {
        details.removeAttribute('open');
        submenu.classList.remove('open');
        document.body.classList.remove('submenu-open');
      } else {
        details.setAttribute('open', '');
        submenu.classList.add('open');
        document.body.classList.add('submenu-open');
      }
    });
  });

  // Add event listener to close button
  const closeButtons = document.querySelectorAll('.close-button');
  closeButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      const details = this.closest('details');
      const submenu = details.querySelector('.mega-menu__content');

      details.removeAttribute('open');
      submenu.classList.remove('open');
      document.body.classList.remove('submenu-open');
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Get all menu links
  const menuLinks = document.querySelectorAll('.mega-menu__link');

  menuLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      // Check if the link has a valid href and is not just toggling a submenu
      if (this.getAttribute('href') !== '#') {
        return;
      }

      // Prevent default link behavior for submenu toggling links
      event.preventDefault();
      
      // Remove 'active' class from all links
      menuLinks.forEach(link => link.classList.remove('active'));
      
      // Add 'active' class to the clicked link
      this.classList.add('active');
      
      // Handle submenu toggling
      const submenu = this.nextElementSibling;
      if (submenu && submenu.classList.contains('submenu')) {
        const isOpen = submenu.classList.contains('open');
        
        // Close all submenus
        const allSubmenus = document.querySelectorAll('.submenu');
        allSubmenus.forEach(sub => sub.classList.remove('open'));
        
        // Toggle the clicked submenu
        if (!isOpen) {
          submenu.classList.add('open');
        }
      }
    });
  });
});

document.querySelectorAll('.mega-menu__link').forEach(link => {
  link.addEventListener('click', function(event) {
    // Check if there's any code preventing the default action
    console.log(event);
  });
});


  $('.cust_Descrip_review__wrap ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });

